import module from 'finanzas/module.js'
import template from './template.html'
import {isDate} from 'angular'

export class CargaMovimientosBancariosHistorialComponent {
  fecha
  data

  constructor ($filter, $state) {
    this.$filter = $filter
    this.$state = $state
  }

  $onChanges (changes) {
    if (changes && !isDate(this.fecha)) {
      this.fecha = new Date()
    }
  }

  buscar () {
    this.$state.go(this.$state.current, {
      fecha: this.$filter('date')(this.fecha, 'yyyy-MM-dd'),
    }, {location: 'replace'})
  }

  modificarFecha (intervalo) {
    this.fecha = new Date(this.fecha.getFullYear(), this.fecha.getMonth(), this.fecha.getDate() + intervalo)

    this.buscar()
  }
}

module.component('financesCargamovimientosbancariosHistorial', {
  controller: CargaMovimientosBancariosHistorialComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/finanzas/components/cargaMovimientosBancarios/historial/component.js